import React from "react";
import { connect } from 'react-redux';

import spinnerGif from '../../../Images/spinner.gif';
import * as ACTIONS from '../../../store/actions/actions';

function Image(props) {
    return (
        <>
            <div className="form-avatar">
              <label className='form-label'>
                Wybierz swoje zdjęcie lub awatar
              </label>
              <p className="input__error">{props.errors.image}</p>
              <div className="form-avatar--buttons">
                <button type="text" className="smallBtn w-100" onClick={(e) => {props.overlayToggle(e); props.setPhotosBoxActive("false"); props.avatarBoxToggle(e); props.action_image_upload_error(false);}}>Wybierz avatar</button>
              </div>

              <div className="form-avatar--buttons">
                <button type="text" className="smallBtn w-100" onClick={(e) => {props.overlayToggle(e); props.setUploadBoxActive("false"); props.uploadBoxToggle(e); props.action_image_upload_error(false);}}>Dodaj własne zdjęcie</button>
              </div>
            </div>
            <div className="preview">
                {props.spinner ? (
                  <img className="spinner" src={spinnerGif} alt="wczytuję zdjęcie" />
                  ) : (
                    <>
                    {!props.user_image ? (
                        null
                      ) : (
                        <img className="previewImg"
                        src={props.user_image}
                        alt="Podgląd Twojego zdjęcia" />
                    )}
                    </>
                )}
            </div>
            {props.image_upload_error ? <p className="input__error" style={{marginTop:'12px'}}>Nie udało się przesłać zdjęcia! Spóbuj ponownie lub odśwież stronę.</p> : null}
        </>
    )
}

function mapStateToProps(state) {
  return {
    user_image: state.user_reducer.user_image,
    data_fetch: state.reducer1.data_fetch,
    spinner: state.reducer1.spinner,
    image_upload_error: state.reducer1.image_upload_error,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    action_image_upload_error: (text) => dispatch(ACTIONS.image_upload_error(text)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Image);

